(function () {
  const Core = window.RB.Core;
  const { res, equip, empower, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Aurok General": {
      abilities: [
        empower({ energy: 3, pips: 1, anyPower: 0, domains: ["order"] }),
      ],
      auraMightSpecs: [
        {
          n: 2,
          cond: { k: "selfEmpowered" },
          who: "friendlyUnits",
          targetCond: { k: "selfEmpowered" },
        },
      ],
    },

    "Escaped Grayback": {
      abilities: [
        empower({ energy: 0, pips: 0, anyPower: 0, domains: null }, { costKillFriendly: true }),
      ],
      selfMightSpecs: [{ n: 2, cond: { k: "selfEmpowered" } }],
    },

    "Horns of the Dragon": {},

    "Shady Spectacles": {
      abilities: [
        equip({ energy: 1, pips: 1, anyPower: 0, domains: ["order"] }),
      ],
      onAttach: {
        targets: [
          {
            bind: "_cp",
            spec: { type: "unit", friendly: true, notHost: true },
            prompt: "Shady Spectacles: the equipped unit becomes a copy of which unit?",
          },
        ],
        program: [{ op: "copyHost", from: "$_cp" }],
      },
    },

    "Shen, Leader of the Kinkou Order": {
      triggers: [
        {
          on: "hold",
          optional: false,
          label: "When I hold, if there is exactly one other unit you control here, you score 1 point",
          targets: [],
          program: [
            {
              op: "if",
              cond: { k: "atBfWithOtherFriendly", n: 1 },
              then: [{ op: "points", n: 1 }],
            },
          ],
          selfBf: true,
          you: true,
        },
      ],
    },

    "Solari Sunhawk": {
      abilities: [
        empower({ energy: 2, pips: 0, anyPower: 0, domains: null }),
      ],
      selfMightSpecs: [{ n: 1, cond: { k: "selfEmpowered" } }],
      selfKwSpecs: [{ name: "deflect", value: 2, cond: { k: "selfEmpowered" } }],
    },

    "Soulspinner": {},

    "Heart of the Tempest": {
      triggers: [
        {
          on: "played", label: "permanent played from outside your hand: empower me",
          condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evNotFromHand" }] },
          program: [{ op: "empowerSource" }],
        },
        {
          on: "finalizedCard", label: "spell played from outside your hand: empower me",
          condSpec: {
            k: "and",
            conds: [{ k: "evYou" }, { k: "evNotFromHand" }, { k: "evType", type: "spell" }],
          },
          program: [{ op: "empowerSource" }],
        },
      ],
      abilities: [
        {
          label: "Disempower me: give a unit [Assault 2] this turn",
          disempowerSelf: true,
          exhausts: true,
          action: true,
          targets: [
            {
              bind: "t", spec: { type: "unit" },
              prompt: "Give which unit [Assault 2] this turn?",
            },
          ],
          program: [{ op: "grant", to: "$t", keyword: "assault", kwValue: 2, dur: "turn" }],
        },
      ],
    },

    "Lightning Rush": {
      flowCost: { energy: 2, pips: 0, anyPower: 1, domains: null },
      play: [{
        op: "lookTopTake", n: 3, optional: true, take: "hand", restTo: "trash",
        prompt: "Draw which of the top 3? (the rest go to your trash)",
      }],
    },

    "Dragon Form": {
      targets: [{
        bind: "t", spec: { type: "unit" },
        prompt: "Whose base Might becomes 5 this turn?",
      }],
      play: [{ op: "grant", to: "$t", setMight: 5, dur: "turn" }],
      flowCost: { energy: 3, pips: 0, anyPower: 0, domains: null },
    },

    "Disciple of Shen": {
      selfKwSpecs: [{ name: "shield", value: 3, cond: { k: "atBfWithOtherFriendly", n: 1 } }],
    },

    "Masa, Crashing Thunder": {
      addCosts: [{
        optional: true,
        cond: null,
        label: "Masa, Crashing Thunder",
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["order"] },
        thenTargets: [],
        then: [
          {
            op: "choose", bind: "e", min: 0,
            spec: { type: "unit", enemy: true, atBf: true },
            prompt: "Stun which enemy unit at a battlefield?",
          },
          { op: "stun", to: "$e" },
        ],
      }],
    },

    "Reluctant Leader": {
      triggers: [{
        on: "played",
        you: true,
        label: "another unit played: +2 Might",
        condSpec: { k: "and", conds: [{ k: "evOther" }, { k: "evType", type: "unit" }] },
        program: [buff("source", 2)],
      }],
    },

    "Ki Barrier": {
      targets: [{
        bind: "t", spec: { type: "unit" },
        prompt: "Prevent the next 7 damage to which unit?",
      }],
      play: [{ op: "prevent", to: "$t", amount: 7, dur: "turn" }],
    },

    Lacerate: {
      targets: [{
        bind: "t", spec: { type: "unit" },
        prompt: "Disempower and possibly kill which unit?",
      }],
      play: [
        {
          op: "if", cond: { k: "targetEmpowered", bind: "t" },
          then: [{ op: "disempower", to: "$t" }],
        },
        {
          op: "if", cond: { k: "targetMightAtMost", bind: "t", n: 3 },
          then: [{ op: "kill", to: "$t" }],
        },
      ],
      flowCost: { energy: 4, pips: 2, anyPower: 0, domains: ["order"] },
    },

    "Noxian Emissary": {
      abilities: [empower({ energy: 1, pips: 1, anyPower: 0, domains: ["order"] })],
      deathknell: [],
      triggers: [{
        on: "dies",
        self: true,
        label: "Empowered Deathknell: two Recruits",
        condSpec: { k: "selfEmpowered" },
        program: [{ op: "token", name: "Recruit", n: 2 }],
      }],
    },

    "Sacred Protector": {
      noCombatDamage: { k: "not", cond: { k: "atBfWithOtherFriendly", n: 1 } },
    },

    "Kennen, Keeper of Balance": {
      play: [{
        op: "may",
        prompt: "Pay 2 Energy to Stun a unit?",
        then: [
          {
            op: "payCost", varKey: "kennenPlay", skipOnFail: 2,
            cost: { energy: 2, pips: 0, anyPower: 0, domains: null },
          },
          {
            op: "choose", bind: "s", min: 0, spec: { type: "unit" },
            prompt: "Stun which unit?",
          },
          { op: "stun", to: "$s" },
        ],
      }],
      triggers: [{
        on: "attack",
        self: true,
        label: "attack: pay 2 Energy to Stun a unit",
        program: [{
          op: "may",
          prompt: "Pay 2 Energy to Stun a unit?",
          then: [
            {
              op: "payCost", varKey: "kennenAttack", skipOnFail: 2,
              cost: { energy: 2, pips: 0, anyPower: 0, domains: null },
            },
            {
              op: "choose", bind: "s", min: 0, spec: { type: "unit" },
              prompt: "Stun which unit?",
            },
            { op: "stun", to: "$s" },
          ],
        }],
      }],
      selfMight: function (state, iid) {
        const o = state.objs[iid];
        if (!o || !o.loc) return 0;
        const stunned = Core.boardObjs(state, function (u, i) {
          return u.controller !== o.controller && !!u.stunned &&
            Core.sameLoc(u.loc, o.loc) && Core.isType(state, i, "unit");
        });
        return stunned.length ? 2 : 0;
      },
    },

    "Ambessa, Respected and Feared": {
      abilities: [empower({ energy: 1, pips: 2, anyPower: 0, domains: ["order"] })],
      selfKwSpecs: [{ name: "assault", value: 2, cond: { k: "selfEmpowered" } }],
      triggers: [{
        on: "attack", self: true,
        condSpec: { k: "selfEmpowered" },
        label: "Empowered attacker: kill an enemy unit here with less Might than me",
        targets: [{
          bind: "t",
          spec: { type: "unit", enemy: true, here: true, lessMightThanSource: true },
          prompt: "Kill which enemy unit here with less Might than me?",
        }],
        program: [{ op: "kill", to: "$t" }],
      }],
    },

    "Decree of Unity": {
      targets: [{
        bind: "t",
        spec: {
          orSpecs: [
            { type: "unit", enemy: true, domain: "chaos" },
            { type: "gear", enemy: true, domain: "chaos" },
          ],
        },
        prompt: "Kill which enemy Chaos unit or gear?",
      }],
      play: [{ op: "kill", to: "$t" }],
    },

    "Keeper of Law": {
      costMods: [{
        energyLess: 2,
        powerLess: 1,
        cond: {
          k: "count",
          spec: { zone: "battlefield", friendly: true, unitsThere: 2, unitsThereCmp: "exactly" },
        },
      }],
    },

    "Hungry Wolf": {
      abilities: [{
        cost: { energy: 0, pips: 1, anyPower: 0, domains: ["order"] },
        label: "Ready me and give me +1 Might this turn",
        oncePerTurn: true,
        cond: { k: "turnFact", key: "choseEnemyUnit", n: 1 },
        program: [
          { op: "ready", to: "source" },
          buff("source", 1),
        ],
      }],
    },

    "Kayle, Justified": {
      maxEmpower: 3,
      abilities: [empower({ energy: 3, pips: 0, anyPower: 0, domains: null })],
      selfMightSpecs: [
        { n: 2, cond: { k: "empoweredTimes", n: 1 } },
        { n: 2, cond: { k: "empoweredTimes", n: 2 } },
        { n: 2, cond: { k: "empoweredTimes", n: 3 } },
      ],
      selfKwSpecs: [
        { name: "deflect", value: 3, cond: { k: "empoweredTimes", n: 3 } },
        { name: "ganking", value: null, cond: { k: "empoweredTimes", n: 3 } },
      ],
    },

    "Glowstone": {
      abilities: [
        empower(res(0, 0, 2, null)),
        {
          label: "Disempower this, exhaust: a player gains control of this and recalls it",
          disempowerSelf: true, exhausts: true, action: true,
          program: [
            {
              op: "option", varKey: "gs",
              prompt: "Who gains control of Glowstone?",
              options: ["You", "Your opponent"],
            },
            {
              op: "if", cond: { k: "varEq", key: "gs", value: 0 },
              then: [{ op: "takeControl", to: "source", recall: true }],
              else: [{ op: "takeControl", to: "source", recall: true, toPlayer: "opponent" }],
            },
          ],
        },
      ],
      triggers: [{
        on: "endOfTurn", you: true,
        label: "end of your turn: kill this and deal 5 to all units you control",
        program: [
          { op: "deal", spec: { type: "unit", friendly: true }, n: 5 },
          { op: "kill", to: "source" },
        ],
      }],
    },

    "Fallen Feline": {
      play: [{ op: "nameChoice", kind: "card", type: "spell", from: "opponent", prompt: "Name a spell" }],
      restrictNamedSpell: { type: "spell", whileAtBf: true },
    },
  });
})();
